const config = {
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

export default config;
